import { FC } from 'react'
import { useIntl } from 'react-intl'

import { useUsersProfilDeliverAddressDuring } from 'services/profile/profile.hooks'

import UserDetailsAddressForm from './UserDetailsAddressForm'

interface UserDetailsAddressDuringRentalProps {
  onBack: () => void
}

const UserDetailsAddressDuringRental: FC<UserDetailsAddressDuringRentalProps> = ({ onBack }) => {
  const { formatMessage } = useIntl()
  const { usersProfilDeliverAddressDuring, usersProfilDeliverAddressDuringUpdate } =
    useUsersProfilDeliverAddressDuring()

  return (
    <UserDetailsAddressForm
      onBack={onBack}
      title={formatMessage({ id: 'userDetails.addressDuring', defaultMessage: 'Adres do doręczeń' })}
      subtitle={formatMessage({
        id: 'userDetails.addressDuring2',
        defaultMessage: 'W trakcie trwania umowy'
      })}
      address={usersProfilDeliverAddressDuring}
      onSave={(values) => usersProfilDeliverAddressDuringUpdate.mutateAsync(values)}
    />
  )
}

export default UserDetailsAddressDuringRental
